import type { FaireProductEntity } from "../../entity_types/product";

export const p_t2vxwbjv63: FaireProductEntity = {
  token: "p_t2vxwbjv63",
  type: "product",
  name: "Wood Puzzle - Smile God Loves You",
  brandToken: "b_29xxo8ggi7",
  brandName: "Swanson Christian Products",
  imageUrl:
    "https://cdn.faire.com/fastly/53ffb924a5644262ff3aedf0f9dfd47a36ecccc3124991d5e742bc1e5d9a30d8.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/48ac3ef0a92e9b4433938a25816243c08bf49f9d1d84e436cd7b9d7b70689c0d.webp",
    "https://cdn.faire.com/fastly/5f6bd7db40a0fa78eb67c72a18e995859131606c791fb7ea69e1539097d39972.webp",
    "https://cdn.faire.com/fastly/6d02f253061ff19f26670cddf6971d053c82460b5fb11c53a2e782cc4ea6c0da.jpeg",
    "https://cdn.faire.com/fastly/9e0bea501ddf16acfb027ba6e61371e073e6a92966f7dddc1a4cad5bbe23f579.webp",
    "https://cdn.faire.com/fastly/ade1d320a98ea4f9090a22db5d21b7270d0091fa226e34cf26a30d87a3eebf6f.webp",
    "https://cdn.faire.com/fastly/1dc96861fdfb05c2de347e02f645fd25c5548d0db27d94d8d0914799b8215c63.webp",
    "https://cdn.faire.com/fastly/fcc4222f57b9daf695fa714d5917ddd2f50e82c0b18b8f9c10ed441c73ffc669.webp",
  ],
  priceDollars: 9.91,
  description:
    '"Introducing our newest puzzle! This wooden kids puzzle is designed to engage young minds with its vibrant colors and smooth shapes. With a yellow star, pink heart, green circle, purple square, blue oval, and orange triangle, this puzzle offers a fun and interactive learning experience.\r\n\r\nCrafted with care, each wooden shape is designed with a little red plastic peg, making it easy for little hands to pick up and manipulate. The puzzle frame features the uplifting message, ""Smile, God Loves You!"" A constant reminder of love and joy.\r\nSafety is our top priority, which is why these wooden shapes are meticulously crafted with smooth edges. This ensures a safe playtime experience for children of all ages, providing peace of mind for parents.\r\n\r\nBut that\'s not all! This puzzle goes beyond its engaging make and design. Under each puzzle piece, you will discover a scripture verse intended to inspire and encourage young hearts. With verses like John 3:16, Jeremiah 29:11, and Colossians 3...',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:32.779Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
